import * as EVENTS from '../constants/external-events';
import OrchCustomData from '../helpers/orch-custom-data';
import sendMessageToVisaSrci from '../helpers/send-message-to-visa-srci';
/* all participating networks init response is availble in orchCustomData
* check the supported networks and if all are failed send the response back to SRCi
* together with supportedNetworks
*/
const handleInit = () => {
  // form identityLookup response
  // send to srcUI via postmessage
  const supportedNetworks = OrchCustomData.srcSdks.appConfig.supportedNetworks || [];
  const eventId = EVENTS.ORCH_INIT;
  sendMessageToVisaSrci(eventId, { supportedNetworks });
};

export default handleInit;
